import React, { ReactNode } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import mapValues from 'lodash/mapValues';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  label: {
    ...theme.fonts.label,
    color: theme.colors.inkSecondary,
    paddingBottom: theme.marginBase,
  },
  container: {
    lineHeight: '100%',
  },
}));

const useColorStyle = createUseStyles((theme: Theme): { [p: string]: any } => {
  return mapValues(theme.colorDefinitions, (def) => ({
    color: def.accessible,
  }));
});

interface Props {
  label?: ReactNode;
  className?: string;
  children: React.ReactNode;
  color?: Colors;
}

export const LabeledSection: React.FC<Props> = ({
  label,
  children,
  className,
  color = 'inkSecondary',
}) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const colorClasses = useColorStyle({ theme });

  return (
    <div className={classnames(classes.container, className)}>
      {label && (
        <p className={classnames(classes.label, colorClasses[color])}>
          {label}
        </p>
      )}
      {children}
    </div>
  );
};
